import axios from 'axios';

class Logger {
  constructor() {
    const hostURL = window.location.protocol + '//' + window.location.host;
    this.baseURL = `${hostURL}/svc/billing/v1/logger`;
    this.defaultPayload = {
      // read cw_conversation from query string
      cw_conversation: window.location.search.includes('cw_conversation=')
        ? window.location.search.split('cw_conversation=')[1]
        : null,
      widget_version: window.hooryWebChannel.releaseVersion,
      assistantType: window.hooryWebChannel.assistantType,
      greetingEnabled: window.hooryWebChannel.greetingEnabled,
      enabledFeatures: window.hooryWebChannel.enabledFeatures,
      userAgent: navigator.userAgent,
    };
  }

  logUserAction(level, message, additionalData = {}) {
    if (level && level !== 'create-message-info') {
      // TODO: Disabling the logger for now due to the svc/widget endpoint not being available
      return;
    }

    const basePayload = {
      level: level,
      message: message,
      timestamp: new Date().toISOString(),
      conversation: {
        id: window.hooryCurrentConversation,
        display_id: window.hooryCurrentConversationDid,
      },
      ...this.defaultPayload,
    };

    // Merge the base payload with any additional data
    const payload = { ...basePayload, ...additionalData };

    try {
      axios.post(this.baseURL, payload);
    } catch (error) {
      // Ignore error
    }
  }
}

export default Logger;
